<template>
  <div id="video-archives" class="container row">



    <app-navigation></app-navigation>


    <div class="video-archives-title-wrapper">
      <h4 class="video-archives-title">VIDEO ARCHIVES</h4>
    </div>


    <div v-for="(videos, categoryId) in videosByCategory" class="category row">
      <app-category :videos="videos" :categoryId="categoryId"></app-category>
    </div>

  </div>
</template>

<script>
  import Navigation from './Navigation.vue'
  import thisismApi from '@/api/thisism-api'
  import _ from 'lodash'
  //  import { VIDEO_CATEGORIES, MEDIA_TYPES, toName } from '../consts'
  import Category from './VideoArchivesCategory.vue'

  export default {
    data () {
      return {
//        VIDEO_CATEGORIES,
//        MEDIA_TYPES,
        videosByCategory: {}
      }
    },
    components: {
      appCategory: Category,
      appNavigation: Navigation
    },
//    methods: {
//      getCategoryName (value) {
//        return toName(VIDEO_CATEGORIES, value)
//      },
//      getMediaTypeName (value) {
//        return toName(MEDIA_TYPES, value)
//      }
//    },
    created () {
      thisismApi.getVideos().then(data => {
        this.videosByCategory = _.groupBy(data, 'category')
//        console.log('video by category', this.videosByCategory)
      })
    }
  }
</script>

<style lang="scss" scoped>

  @import "../style/common";

  #video-archives {
    margin: 20px auto;
  }

  .container {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  .video-archives-title-wrapper {
    display: block;
    margin: 60px 35px 0;
  }

  .video-archives-title {
    display: inline;
    padding: 5px 20px;
    background-color: white;
    color: black;
    font-size: 2.6rem;
  }

</style>



// WEBPACK FOOTER //
// VideoArchives.vue?4687ca2c